import * as React from 'react';

export function useIsMobile(breakpoint = 768) {
  const getIsMobile = React.useCallback(() => {
    if (typeof window === 'undefined') return false;
    return window.innerWidth < breakpoint;
  }, [breakpoint]);

  const [isMobile, setIsMobile] = React.useState<boolean>(getIsMobile);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(getIsMobile());
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [getIsMobile]);

  return isMobile;
}

